import { ReactComponent as InstagramLogo } from '../assets/instagram-social-logo.svg';
import { ReactComponent as FacebookLogo } from '../assets/facebook-social-logo.svg';
import { ReactComponent as LinkedinLogo } from '../assets/linkedin-social-logo.svg';
import { ReactComponent as TwitterLogo } from '../assets/twitter-social-logo.svg';
import { ReactComponent as YoutubeLogo } from '../assets/youtube-social-logo.svg';
import { ReactComponent as TikTokLogo } from '../assets/tiktok-social-logo.svg';

export const SOCIAL_LINKS = [
  {
    href: `https://www.instagram.com/agileengine/`,
    icon: InstagramLogo,
    label: 'AgileEngine Instagram',
  },
  {
    href: `https://www.facebook.com/agileengine/`,
    icon: FacebookLogo,
    label: 'AgileEngine Facebook',
  },
  {
    href: `https://www.linkedin.com/company/agileengine/`,
    icon: LinkedinLogo,
    label: 'AgileEngine Linkedin',
  },
  {
    href: `https://twitter.com/agileengine`,
    icon: TwitterLogo,
    label: 'AgileEngine Twitter',
  },
  {
    href: `https://www.youtube.com/channel/UCy7jhgX7lqo13llN6NZr6Mg`,
    icon: YoutubeLogo,
    label: 'AgileEngine Youtube',
  },
  {
    href: `https://www.tiktok.com/@agileengine`,
    icon: TikTokLogo,
    label: 'AgileEngine TikTok',
  },
];
